import { ReactNode } from "react";

import Box from "ds/components/Box";

import styles from "./styles.module.css";

type StepsGroupProps = {
  children: ReactNode;
};

const StepperStepsGroup = ({ children }: StepsGroupProps) => {
  return (
    <Box direction="column" className={styles.stepsGroup}>
      {children}
    </Box>
  );
};

StepperStepsGroup.displayName = "DS.Stepper.StepsGroup";

export default StepperStepsGroup;
